// Site Configuration
// Set to true when ready to launch the app publicly
export const SITE_LIVE = true;

// Pages that are always accessible, even when site is not live
export const ALWAYS_ACCESSIBLE = [
  '/beta',
  '/terms',
  '/privacy',
  '/shelfpulse',
  '/shelfpulse/terms',
  '/shelfpulse/privacy',
];
